import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import styles from './index.module.scss';

const cx = classNames.bind(styles);
const regEx = /[^a-z0-9]/gi;

const Textarea = ({
  value, disabled, onChange, label, name, id, className
}) => {
  const [active, setActive] = useState(false);
  const ref = useRef(null);

  useEffect(() => setActive(!!value || value === 0), [value]);

  const focusArea = () => {
    if (!disabled) {
      ref.current.focus();
    }
  };

  const areaId = id || `textarea-${label.toLowerCase().replace(regEx, '')}`;

  return (
    <div className={cx(className, { areaContainer: true })} onClick={focusArea}>
      <div className={styles.areaContent}>
        <label
          className={cx({ label: true, labelActive: active })}
          id={`label-${label.toLowerCase().split(' ').join('_')}`}
          htmlFor={areaId}
        >
          {label}
        </label>
        <textarea
          ref={ref}
          onFocus={() => setActive(true)}
          onBlur={(e) => setActive(e.target.value && e.target.value.length)}
          className={styles.area}
          id={areaId}
          disabled={disabled}
          onChange={onChange}
          name={name}
          value={value}
        />
      </div>
    </div>
  );
};

Textarea.propTypes = {
  value: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
};

export default Textarea;
